import Const from '../components/Const';
import { setAIisDownMessage, setAIErrorMessage, 
         setSavePostInfoErrorMessage, setNotUniversallySupportedVideoCodecMessage, 
         setValidateCodecDownMessage } from '../components/Utils.js';
import { clipBoardFunc, httpFunc } from './AndrodIosAppUtils.js';

const INVALID_IMG_URL_STATUS = -8;

export async function copyToClipBoard(text) {
  if (clipBoardFunc) {
    await copyToClipBoardAndroid(text);
  }
  else {
    await copyToClipBoardCommon(text);
  }
}

async function copyToClipBoardCommon(text) {
  try {
      if (navigator.clipboard) {
          await navigator.clipboard.writeText(text);
      }
      else {
          // this was done for craker because navigator.clipboard.writeText requires https ot localhost
          // (craker works with http). Will keep it for some time and then remove
          await alternativeClipBoardCopy(text);
      }
    }
    catch (error) {
      console.log(error);
    }
}

function alternativeClipBoardCopy(text) {
  let textArea = document.createElement("textarea");
  
  textArea.value = text;
  // make the textarea out of viewport
  textArea.style.position = "fixed";
  textArea.style.left = "-999999px";
  textArea.style.top = "-999999px";
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
      
  return new Promise((res, rej) => {
      // here the magic happens
      document.execCommand('copy') ? res() : rej();
      textArea.remove();
  });
}

export async function copyToClipBoardAndroid(text) {
  try {
    await clipBoardFunc.write({
      string: text
    });
  }
  catch (error) {
    console.log(error);
  }
}

export async function invokeServer(serviceUrl, data, that) {
  let response;

  if (httpFunc) {
    response = await invokeServerAndroid(serviceUrl, data, that);
  }
  else {
    response = await invokeServerCommon(serviceUrl, data, that);
  }
  return response;
}

export async function invokeServerCommon(serviceUrl, data, that) {
  let response;
  let parms = {};
  let serverResult = null;
  let serverError = null;
  
  Object.assign(parms, Const.INVOKE_SERVICE_PARMS);
  if (parms.hasOwnProperty('credentials')) {
    delete parms.credentials;
  }
  // parms.headers['Access-Control-Allow-Origin'] = '*';
  await that.setState({
    serviceInvocationStatus :  Const.SERVICE_IS_BEIGNG_INVOKED
  });
  parms.body = JSON.stringify(data);
  await fetch(serviceUrl, parms)
    .then(res => res.json())
    .then(
      (result) => {
        serverResult = result;
        serverResultLogic(result, that, serviceUrl);
      },
      (err) => {
        serverError = err;
        serverErrorLogic(serverError, that, serviceUrl);
      }
  )
  response = {
    result : serverResult,
    error : serverError
  }
  return response;
}

export async function invokeServerAndroid(serviceUrl, data, that) {
  let response;
  let result;
  let serverResult = null; 
  let serverError = null;
  let parms = {
      url: serviceUrl,
      headers: Const.INVOKE_SERVICE_PARMS.headers,
      data: data
  };
  
  await that.setState({
      serviceInvocationStatus :  Const.SERVICE_IS_BEIGNG_INVOKED
  });
  try {
      // result is almost the same as parms object, wuth the following prop changed
      // result.data = {statusCode : 200 }; and this prop added result.status = 200
      result = await httpFunc.post(parms);
      serverResult = result.data;
      serverResultLogic(serverResult, that, serviceUrl);
  }
  catch (error) {
      serverError = error;
      serverErrorLogic(serverError, that, serviceUrl);
  }
  response = {
    result : serverResult,
    error : serverError
  }
  return response;
}

export async function serverResultLogic(result, that, serviceUrl) {
  let  errorLevel = Const.NO_ERROR_LEVEL;
 
  console.log(result);
  if (result.statusCode !== Const.OK) {
    errorLevel = Const.SYS_ERROR_LEVEL;
    if (serviceUrl === Const.VPS_SERVER_URL_SAVE_POST_INFO) {
      await setSavePostInfoErrorMessage(that);
    }
    else if (serviceUrl === Const.VPS_SERVER_URL_VALIDATE_CODEC) {
      setNotUniversallySupportedVideoCodecMessage(that, result.codec); // no await needed
    }
    else if ((serviceUrl === Const.VPS_SERVER_URL_RETRY_VIDEO) && 
                (serviceUrl === Const.VPS_SERVER_URL_GET_VIDEO_SETTINGS) &&
                    (result.statusCode === INVALID_IMG_URL_STATUS)) {
      // rety video with invalid image url (expired) - we don't issue any message
      // existing video remains in place
    }
    else {
      await setAIErrorMessage(that);
    }
  }
  that.setState({
      serviceInvocationStatus :  Const.SERVICE_CALL_IS_COMPLETE,
      serviceStatusCode : result.statusCode,
      serviceErrorLevel : errorLevel 
  });
}

export async function serverErrorLogic(err, that, serviceUrl) {
  if ((serviceUrl !== Const.VPS_SERVER_URL_GET_VIDEO_SETTINGS) ) {
    console.log(err);
  }
  else if (serviceUrl === Const.VPS_SERVER_URL_VALIDATE_CODEC) {
    setValidateCodecDownMessage(that);
  }
  else if (serviceUrl !== Const.VPS_SERVER_URL_GET_VIDEO_SETTINGS) {
    await setAIisDownMessage(that);
  }
  that.setState({
    serviceStatusCode : Const.SYS_ERROR_SERVER_IS_DOWN,
    serviceErrorLevel : Const.SYS_DOWN_LEVEL,
    serviceInvocationError : true
  });
}

export async function getSharedPost(sharedPostUrl) {
  let response = await fetch(sharedPostUrl); 

  if (!response.ok) { 
    console.log('Error fetching share post: ' + sharedPostUrl);
  }
}